import { H1, Span } from '@ahmdigital/ui';
import { ReactNode } from 'react';
import styled from 'styled-components';

type NavigationHeaderTitleProps = {
  children: ReactNode;
  className?: string;
  useHeading?: boolean;
};

const NavigationHeaderTitle = ({ children, className, useHeading = false }: NavigationHeaderTitleProps) => {
  const TitleElement = useHeading ? H1 : Span;
  return (
    <TitleElement className={className} looksLike="h5">
      {children}
    </TitleElement>
  );
};

const StyledNavigationHeaderTitle = styled(NavigationHeaderTitle)`
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;

export const NavigationUpliftHeaderTitle = styled(StyledNavigationHeaderTitle)`
  color: ${({ theme }) => theme.colors.black};
  padding: 1rem;
  margin-bottom: 0;
  font-size: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black};

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    border-left: 0.5rem solid ${({ theme }) => theme.colors.black};
    border-right: 0.5rem solid ${({ theme }) => theme.colors.black};
  }

  @media (min-width: ${({ theme }) => theme.media.md}) {
    padding-left: 16.5rem;
  }
`;

export default StyledNavigationHeaderTitle;
